
import { defineComponent, reactive, ref } from "vue";
import { Roles, Menu } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ElMessageBox, ElMessage } from "element-plus";
import type { ElTree, FormInstance, FormRules } from "element-plus";
import type Node from "element-plus/es/components/tree/src/model/node";
import KTModalRoles from "@/components/modals/forms/RolesModal.vue";
import RoleFilter from "@/components/dropdown/RoleFilter.vue";
import { CookieComponent, MenuComponent } from "@/assets/ts/components";
import { componentSize } from "@/utils/userMenuUtil";

interface DataForm {
  id: number | null;
  cTenNhomQuyen: string | null;
  cMoTa: string | null;
}

interface Role {
  nMaChucNang: number | null;
  nMaNhomQuyen: number | null;
  cMoTa: string | null;
  cNguoiCapNhatCuoi: string | null;
  cNguoiTao: string | null;
  cTenNhomQuyen: string | null;
  dNgayCapNhatCuoi: string | null;
  dNgayTao: string | null;
  nTinhTrang: number | null;
}

interface RoleMenus {
  cIcon: string | null;
  cNguoiCapNhatCuoi: string | null;
  cNguoiTao: string | null;
  cQuyen: string | null;
  cTenChucNang: string | null;
  cUrl: string | null;
  children: Array<RoleMenus> | null;
  dNgayCapNhatCuoi: string | null;
  dNgayTao: string | null;
  level: number | null;
  nLoai: number | null;
  nMaChucNang: number | null;
  nMaChucNangCha: number | null;
  nSystem: number | null;
  nThuTu: number | null;
  nTinhTrang: number | null;
  parentName: string | null;
  userName: string | null;
}

export default defineComponent({
  name: "roles",
  components: { KTModalRoles, RoleFilter },
  setup() {
    
    const perms = ref(CookieComponent.get("permissions") ? JSON.parse(CookieComponent.get("permissions") as string) : []);
    const checkStrictly = ref<boolean>(false);
    const formRef = ref<FormInstance>();
    const checkAll = ref<boolean>(false);
    const treeRef = ref<InstanceType<typeof ElTree>>();
    const store = ref(useStore());
    const router = ref(useRouter());

    const size = ref<string>("");
    const pageRequest = reactive({
      columnFilters: {
        cTenNhomQuyen: { value: "" as string | null },
      },
      pageSize: 10 as number | null,
      pageNum: 1 as number | null,
    });

    const tableData = ref({
      content: [] as Array<Role> | null,
      pageSize: 10 as number,
      pageNum: 1 as number,
      totalSize: 0 as number,
      totalPages: 0 as number,
    });

    const menuTree = ref<Array<RoleMenus>>([]);
    const selectedMenu = ref<Array<RoleMenus>>([]);

    const rules = reactive<FormRules<DataForm>>({
      cTenNhomQuyen: [
        {
          required: true,
          message: "Bạn chưa nhập tên nhóm quyền",
          trigger: "blur",
        },
      ],
      cMoTa: [
        {
          required: true,
          message: "Bạn chưa nhập mô tả",
          trigger: "blur",
        },
      ],
    });

    const treeProp = ref({
      icon: "icon",
      lastUpdateBy: "lastUpdateBy",
      createBy: "createBy",
      perms: "perms",
      name: "label",
      url: "url",
      children: "children",
      lastUpdateTime: "lastUpdateTime",
      createTime: "createTime",
      level: "level",
      nChucNangNguoiDung: "nChucNangNguoiDung",
      nChucNangQuanTriVien: "nChucNangQuanTriVien",
      type: "type",
      id: "id",
      parentId: "parentId",
      orderNum: "orderNum",
      delFlag: "delFlag",
      parentName: "parentName",
      userName: "userName",
    });

    const dataForm = reactive<DataForm>({
      id: null,
      cTenNhomQuyen: "",
      cMoTa: "",
    });

    const selected = ref<Role>();
    const modalType = ref<number>(0);

    const clearForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.resetFields();
      dataForm.id = null;
    };

    const defaultValues = reactive<DataForm>({
      id: null,
      cTenNhomQuyen: "",
      cMoTa: "",
    });
    const loading = ref<boolean>(false);

    return {
      perms,
      checkStrictly,
      router,
      loading,
      defaultValues,
      selectedMenu,
      dataForm,
      formRef,
      selected,
      checkAll,
      treeRef,
      treeProp,
      store,
      pageRequest,
      tableData,
      menuTree,
      modalType,
      rules,
      size,
      clearForm,
    };
  },
  methods: {
    /* find Page Role group start */

    handleChangePage(val) {
      this.handleFindRole(val, this.pageRequest.pageSize);
    },

    handleChangeSize(val) {
      this.handleFindRole(this.pageRequest.pageNum, val);
    },

    handleFindPage(val) {
      this.pageRequest.columnFilters.cTenNhomQuyen.value = val;
      this.handleFindRole(1, this.tableData.pageSize);
    },

    handleFindRole(pageNum, pageSize) {
      this.loading = true;
      if (typeof pageNum == "number") this.pageRequest.pageNum = pageNum;
      else this.pageRequest.pageNum = 1;
      if (typeof pageSize == "number") this.pageRequest.pageSize = pageSize;
      else this.pageRequest.pageSize = 10;
      this.store.dispatch(Roles.findRole, this.pageRequest).then((res) => {
        if (res.code == 200) {
          this.loading = false;
          this.tableData = res.data;
        } else {
          ElMessage({ message: "Thất bại! " + res.msg, type: "error" });
        }
      }).catch(error => {
        ElMessage({ message: "Tìm kiếm thất bại!", type: "error" });
      });;
    },
    /* find Page Role group */

    /* update/create role gruop */

    /* Find Menu Tree start */
    handleFindRoleMenu(item) {
      this.checkStrictly = true;
      this.loading = true;
      const data = { nMaNhomQuyen: item.nMaNhomQuyen };
      this.selected = Object.assign({}, item);
      this.store.dispatch(Roles.findRoleMenu, data).then((res) => {
        if (res.code == 200) {
          this.checkStrictly = false;
          this.loading = false;
          this.selectedMenu = res.data as Array<RoleMenus>;
          let element = document.getElementById("menuTree");
          element?.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          });
          this.treeRef?.setCheckedNodes(res.data);
        } else {
          ElMessage({ message: "Thất bại! " + res.msg, type: "error" });
        }
      }).catch(error => {
        ElMessage({ message: "Tìm kiếm thất bại!", type: "error" });
      });;
    },

    handleFindMenuTree() {
      let userName = CookieComponent.get("userName")
      this.store.dispatch(Menu.findMenu, { columnFilters: { currentSystem: { value: 2 } } }).then((res) => {
        if (res.code == 200) {
          this.menuTree = res.data;
        }
      });
    },

    /* Find Menu Tree end */

    /* draw tree */
    renderContent(
      h,
      {
        node,
        data,
        store,
      }: { node: Node; data: RoleMenus; store: Node["store"] }
    ) {
      return h(
        "span",
        {
          class: "custom-tree-node",
          style: "width:100%; display:flex",
        },
        h(
          "span",
          {
            class: "role-tree-node",
            style: "width:25%",
          },
          null,
          data.cTenChucNang
        ),
        h(
          "span",
          {
            class: "role-tree-node",
            style: "width:10%",
          },
          null,
          h("i", { class: `${data.cIcon}` })
        ),
        h(
          "span",
          {
            class: "role-tree-node",
            style: "width:20%",
          },
          null,
          `${data.nLoai === 1
            ? "Menu Gốc"
            : data.nLoai === 2
              ? "Menu"
              : data.nLoai === 3
                ? "Button"
                : data.nLoai === 4
                  ? "Liên kết ngoài"
                  : ""
          }`
        ),
        h(
          "span",
          {
            class: "role-tree-node",
            style: "width:30%",
          },
          null,
          data.cQuyen
        ),
        h(
          "span",
          {
            class: "role-tree-node",
            style: "width:15%",
          },
          null,
          data.cUrl
        )
      );
    },

    /* check all tree nodes start */
    handleCheckAll() {
      if (this.checkAll) {
        let allMenus = [];
        this.checkAllMenu(this.menuTree, allMenus);
        this.treeRef?.setCheckedNodes(allMenus);
        console.log(this.treeRef)
      } else {
        this.treeRef?.setCheckedNodes([]);
      }
    },

    checkAllMenu(data, allMenus) {
      data.forEach((menu) => {
        allMenus.push(menu);
        if (menu.children) {
          this.checkAllMenu(menu.children, allMenus);
        }
      });
    },

    /* check all tree nodes end */

    /* save role menu  */
    saveRoleMenu() {
      this.loading = true;
      let roleId = this.selected?.nMaNhomQuyen;
      let checkedNodes = this.treeRef?.getCheckedNodes(
        false,
        true
      ) as Array<Role>;
      let roleMenus = [] as Array<{
        nMaNhomQuyen: number | null;
        nMaChucNang: number | null;
      }>;

      for (let i = 0; i < checkedNodes.length; i++) {
        let roleMenu = {
          nMaNhomQuyen: roleId as number,
          nMaChucNang: checkedNodes[i].nMaChucNang as number,
        };
        roleMenus.push(roleMenu);
      }
      if (roleMenus.length == 0) {
        roleMenus.push({
          nMaNhomQuyen: roleId as number,
          nMaChucNang: null
        })
      }
      this.store.dispatch(Roles.saveRoleMenu, roleMenus).then((res) => {
        if (res.code == 200) {
          ElMessage({ message: "Lưu thành công", type: "success" });
          this.handleFindRoleMenu(this.selected);
        } else {
          ElMessage({ message: "Thất bại! " + res.msg, type: "error" });
        }
      }).catch(error => {
        ElMessage({ message: "Lưu thất bại!", type: "error" });
      });;
    },

    /* reset role menu */
    resetRoleMenu() {
      this.checkAll = false;
      let selectedMenuData = [] as any;
      this.selectedMenu.forEach((menu) => {
        selectedMenuData.push(menu);
      });
      this.treeRef?.setCheckedNodes(selectedMenuData);
    },

    /* delete Role group */
    handleDelete(val) {
      /* let params = { id: val.id }; */
      ElMessageBox.confirm("Bạn có chắc muốn xóa nhóm quyền này?")
        .then(() => {
          this.store.dispatch(Roles.deleteRole, [{ nMaNhomQuyen: val.nMaNhomQuyen }]).then((res) => {
            if (res.code == 200) {
              ElMessage({
                message: `Xóa nhóm quyền ${val.cTenNhomQuyen} thành công`,
                type: "success",
              });

              this.handleFindPage(
                this.pageRequest.columnFilters.cTenNhomQuyen.value
              );
            } else {
              ElMessage({ message: "Thất bại! " + res.msg, type: "error" });
            }
          }).catch(error => {
            ElMessage({ message: "Xóa nhóm quyền thất bại!", type: "error" });
          });;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /* open modal start */

    async handleOpenAdd() {
      this.modalType = 0;
      for (let prop in this.dataForm) {
        this.dataForm[prop] = null;
      }
      for (let prop in this.defaultValues) {
        this.defaultValues[prop] = null;
      }
    },

    async handleOpenEdit(val) {
      this.modalType = 1;
      for (let prop in val) {
        if (prop in this.dataForm) this.dataForm[prop] = val[prop];
      }
      for (let prop in val) {
        if (prop in this.defaultValues) this.defaultValues[prop] = val[prop];
      }
    },
    handleCheckPerms(val){
      return this.perms.includes(val)
    }
  },
  mounted() {
    this.size = componentSize();
    onresize = () => {
      this.size = componentSize();
    };

    this.handleFindPage(this.pageRequest.columnFilters.cTenNhomQuyen.value);
    this.handleFindMenuTree();
    MenuComponent.reinitialization();
  },
});
